var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69635 4.68262C8.69635 4.40647 8.9202 4.18262 9.19635 4.18262H15.4709C15.747 4.18262 15.9709 4.40647 15.9709 4.68262C15.9709 4.95876 15.747 5.18262 15.4709 5.18262H9.19635C8.9202 5.18262 8.69635 4.95876 8.69635 4.68262ZM4.93164 7.19242C4.93164 6.91628 5.1555 6.69242 5.43164 6.69242H6.68654H17.9807H19.2356C19.5117 6.69242 19.7356 6.91628 19.7356 7.19242C19.7356 7.46856 19.5117 7.69242 19.2356 7.69242H18.4807V19.114C18.4807 19.413 18.3619 19.6998 18.1504 19.9112C17.939 20.1227 17.6522 20.2414 17.3532 20.2414H7.31399C7.01498 20.2414 6.7282 20.1227 6.51677 19.9112C6.30533 19.6998 6.18654 19.413 6.18654 19.114V7.69242H5.43164C5.1555 7.69242 4.93164 7.46856 4.93164 7.19242ZM7.18654 7.69242V19.114C7.18654 19.1478 7.19997 19.1802 7.22387 19.2041C7.24777 19.228 7.28019 19.2414 7.31399 19.2414H17.3532C17.387 19.2414 17.4194 19.228 17.4433 19.2041C17.4672 19.1802 17.4807 19.1478 17.4807 19.114V7.69242H7.18654Z",
    fill: "#4D4E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.06f4ce624fb01081ccf0896168d2beb8.svg";
export { ForwardRef as ReactComponent };